import { connect } from 'react-redux';
import SesamLink from 'Common/Links/SesamLink';
import PropTypes from 'prop-types';
import React from 'react';

import Page from '../page';
import PageHeader, { PageHeaderTitle } from '../page-header';
import { TabbedNav } from '../tabbed-nav/TabbedNav.view';

const EntityTypePage = (props) => {
  const {
    children,
    subId,
    params: { entityTypeId, modelId },
  } = props;

  return (
    <Page>
      <PageHeader>
        <PageHeaderTitle>
          <SesamLink to={`subscription/${subId}/browse`}>Browse</SesamLink>
        </PageHeaderTitle>
        <PageHeaderTitle>{`Entity type (${entityTypeId})`}</PageHeaderTitle>
      </PageHeader>
      <TabbedNav
        nav={[
          {
            label: 'Overview',
            to: `/subscription/${subId}/browse/entity-types/${modelId}/${entityTypeId}/overview`,
          },
        ]}
      >
        {children}
      </TabbedNav>
    </Page>
  );
};

EntityTypePage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  params: PropTypes.shape({
    entityTypeId: PropTypes.string.isRequired,
    modelId: PropTypes.string.isRequired,
  }).isRequired,
  subId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  subId: state.subscription.id,
});

export default connect(mapStateToProps)(EntityTypePage);
